"use strict";
/// <reference path="irep.js"/>
/* jshint newcap */

IREP.Band = (function (global) {
    var defaults = {

    };

    var Band = function (options) {
        var self = this;

        self.toggleState = 0;

        $.extend(self, defaults, options);
        self.$header = self.$band.find('.header');
        self.$content = self.$band.find('.content');
        self.$footer = self.$band.find('.content');

        self.$band.find('[data-actions~="band-open-footer"]').click(function (e) {
            e.preventDefault();
            TweenLite.to(self.$footer, 1, { height: "610px" });
            self.toggleState = 1;
        });

        self.$band.find('[data-actions~="band-close-footer"]').click(function (e) {
            e.preventDefault();
            TweenLite.to(self.$footer, 1, { height: "290px" });
            self.toggleState = 0;
        });

        self.$band.find('[data-actions~="band-toggle-footer"]').click(function (e) {
            e.preventDefault();
            if (self.toggleState === 1) {
                TweenLite.to(self.$footer, 1, { height: "290px" });
                self.toggleState = 0;
            } else {
                TweenLite.to(self.$footer, 1, { css: { height: "610px" } });
                self.toggleState = 1;
            }
        });

        IREP.ready(function () {
            setTimeout(function () {
                self.$band.waypoint({
                    offset: '50%',
                    handler: function (direction) { self.defaultWaypointHandler(direction, "waypoint"); }
                });

                self.$content.waypoint({
                    offset: '75%',
                    handler: function (direction) { self.defaultWaypointHandler(direction, "content"); },
                    triggerOnce: true
                });
            }, 50);
        });
    };

    Band.prototype.defaultWaypointHandler = function (direction, base) {
        var self = this;
        var waypointAttribute = self.$band.data(base + direction);

        if ($.type(waypointAttribute) === "string") {
            var func = self.effects[waypointAttribute];
            if (typeof func === "undefined") {
                func = self.findFunction(waypointAttribute);
            }

            if (typeof func !== "undefined") {
                func.call(self, self.$band);
            }
        }
    };

    Band.prototype.effects = {
        backgroundSlideUp: function () {
            var self = this;
            TweenMax.to.apply(TweenMax, [self.$header, 0.75, { backgroundPosition: "center center" }]);
        },
        backgroundSlideDown: function () {
            var self = this;
            TweenMax.to.apply(TweenMax, [self.$header, 0.75, { backgroundPosition: "center bottom" }]);
        }
    };
    
    Band.prototype.findFunction = function (functionName) {
        var rootObject = window;
        var functionArray = functionName.split('.');
        for (var i = 0, length = functionArray.length; i < length - 1; i++) {
            rootObject = rootObject[functionArray[i]];
        }

        return rootObject[functionArray[functionArray.length - 1]];
    };

    return Band;
}());

IREP.bands = (function () {
    var bands = [];

    var init = function () {
        var $bands = $('.band');
        var zindex = 50;

        $.each($bands, function (i, band) {
            $(band).find('.content').css('zIndex', --zindex);
            bands.push(new IREP.Band({ $band: $(band) }));
        });
    };

    return {
        init: init
    };
}());
